import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { of, catchError, map, mergeMap, filter } from 'rxjs';
import { videosActions } from '../actions/videos.actions';
import { HttpService } from '../services/http.service';
import { selectLoading } from '../selectors/videos.selector';
import { Store } from '@ngrx/store';

@Injectable()
export class VideosEffects {
    private readonly store = inject(Store);
    private readonly actions = inject(Actions);
    private readonly httpService = inject(HttpService);

    getVideo$ = createEffect(() => {
        return this.actions.pipe(
            ofType(videosActions.getVideo),
            concatLatestFrom(({ id }) => this.store.select(selectLoading(id))),
            filter(([, loading]) => loading === null),
            mergeMap(([action]) => {
                return this.httpService.getVideo(action.id).pipe(
                    map((payload) => videosActions.getVideoSuccess({ payload })),
                    catchError((error) => of(videosActions.getVideoError({ id: action.id, code: error.status }))),
                );
            }),
        );
    });

    getVideoSetLoading$ = createEffect(() => {
        return this.actions.pipe(
            ofType(videosActions.getVideo),
            concatLatestFrom(({ id }) => this.store.select(selectLoading(id))),
            filter(([, loading]) => loading === null),
            map(([action]) => videosActions.setLoading({ id: action.id })),
        );
    });
}
